<template>
  <v-sheet
    rounded
    :class="[
      'check-card relative audience-template-card px-8 py-6 fill-height d-flex flex-column align-start',
    ]"
  >
    <div :class="['audience-template-card__border', template.type.color]" />
    <div class="body-1 font-weight-bold mb-2" v-text="template.name" />
    <div class="body-1" v-text="template.description" />
  </v-sheet>
</template>

<script>
export default {
  name: "AudienceTemplateCardOverview",
  props: {
    template: Object,
  },
}
</script>

<style scoped>
.audience-template-card {
  overflow: hidden;
}

.audience-template-card__border {
  position: absolute;
  width: 8px;
  left: -2px;
  top: -2px;
  bottom: -2px;
  background-color: currentColor;
}
</style>
